/**
 * Production Feature Flag Protection
 * Prevents critical flags from being disabled in production
 */

export const PRODUCTION_FORCED_FLAGS = [
  // ✅ REMOVED 2026-04-30 (PR-C): 'ENABLE_ENHANCED_MONITORING' (flag retired)
  // ✅ REMOVED 2026-04-30 (PR-A): ENABLE_PRINT_PIN_LAYOUT_FIX
  'ENABLE_CUSTOM_MILESTONES',
  // ✅ RETIRED 2026-05-01 (PR-F3): ENABLE_AI_PLAN_ADVISOR (hardcoded true, flag retired)
] as const;

export type ProductionForcedFlag = typeof PRODUCTION_FORCED_FLAGS[number];

/**
 * Check if a flag is production-forced (cannot be disabled in production)
 */
export const isProductionForcedFlag = (flag: string): boolean => {
  // Only enforce in production mode
  if (import.meta.env.MODE !== 'production') {
    return false;
  }
  
  return PRODUCTION_FORCED_FLAGS.includes(flag as ProductionForcedFlag);
};
